import React, { useState } from 'react';
import { Truck, Clock, MapPin } from 'lucide-react';
import { prefectures } from '../../../utils/prefectures';
import type { BulkUpdates } from '../../../types/bulk';
import { BulkApplyButton, BulkFieldRow, bulkSelectClass } from '../BulkFieldRow';

interface BulkShippingFieldsProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkShippingFields({ onUpdate }: BulkShippingFieldsProps) {
  const [shippingResponsibility, setShippingResponsibility] = useState('');
  const [shippingTime, setShippingTime] = useState('');
  const [shippingLocation, setShippingLocation] = useState('');

  return (
    <div className="space-y-4 md:space-y-5">
      <BulkFieldRow
        icon={<Truck className="w-5 h-5 text-gray-500 shrink-0" />}
        label="送料負担を変更"
      >
        <select
          value={shippingResponsibility}
          onChange={(e) => setShippingResponsibility(e.target.value)}
          className={bulkSelectClass}
        >
          <option value="">選択してください</option>
          <option value="buyer">落札者</option>
          <option value="seller">出品者</option>
        </select>
        <BulkApplyButton
          disabled={!shippingResponsibility}
          onClick={() => {
            if (shippingResponsibility) {
              onUpdate({ shippingResponsibility });
              setShippingResponsibility('');
            }
          }}
        />
      </BulkFieldRow>

      <BulkFieldRow
        icon={<Clock className="w-5 h-5 text-gray-500 shrink-0" />}
        label="発送までの日数を変更"
      >
        <select
          value={shippingTime}
          onChange={(e) => setShippingTime(e.target.value)}
          className={bulkSelectClass}
        >
          <option value="">選択してください</option>
          <option value="1-2">1～2日</option>
          <option value="2-3">2～3日</option>
          <option value="3-7">3～7日</option>
        </select>
        <BulkApplyButton
          disabled={!shippingTime}
          onClick={() => {
            if (shippingTime) {
              onUpdate({ shippingTime });
              setShippingTime('');
            }
          }}
        />
      </BulkFieldRow>

      <BulkFieldRow
        icon={<MapPin className="w-5 h-5 text-gray-500 shrink-0" />}
        label="発送元の地域を変更"
      >
        <select
          value={shippingLocation}
          onChange={(e) => setShippingLocation(e.target.value)}
          className={bulkSelectClass}
        >
          <option value="">選択してください</option>
          {prefectures.map(prefecture => (
            <option key={prefecture} value={prefecture}>
              {prefecture}
            </option>
          ))}
        </select>
        <BulkApplyButton
          disabled={!shippingLocation}
          onClick={() => {
            if (shippingLocation) {
              onUpdate({ shippingLocation });
              setShippingLocation('');
            }
          }}
        />
      </BulkFieldRow>
    </div>
  );
}
